import CommonTooltip from '@features/common/components/CommonTooltip';
import InformationIconButton from '@features/common/components/InformationIconButton';
import { getCdnStaticUrl } from '@features/common/store/common.selectors';
import Image from 'next/image';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { IOrganizeStatisticBoxProps } from '../models/organize-state.model';

const OrganizeStatisticBox = (props: IOrganizeStatisticBoxProps) => {
	const { svgIcon, source, translationKey, value } = props;
	const cdnStatic = useSelector(getCdnStaticUrl);
	const { formatMessage } = useIntl();

	return (
		<>
			<div className='flex flex-col items-center lg:w-[280px] xmd:w-[250px] md:w-[230px] sm:w-[190px] w-[270px]'>
				<div className='relative scale-[100%] lg:h-[2.8125rem] lg:w-[2.8125rem] sm:h-[2.188rem] sm:w-[2.188rem] h-[1.875rem] w-[1.875rem] sm:mb-5 mb-[0.9375rem]'>
					<Image
						alt={`${svgIcon}`}
						unoptimized={true}
						src={`${cdnStatic}/${svgIcon}.svg`}
						priority={true}
						layout='fill'
					/>
				</div>
				<span
					className='text-dark-800 font-semibold xmd:text-[3.438rem] text-[2.5rem]'
					style={{ fontFamily: "'Montserrat', normal" }}
				>
					{value}
				</span>
				<div className='w-[6.25rem] border border-main-500 sm:my-5 my-[0.9375rem]' />

				<div>
					<CommonTooltip
						className='flex items-center justify-start'
						text={source as string}
						type='contained'
						pageView='Organize'
					>
						<p className='text-grayBlue-700 lg:text-xlg text-base text-center'>
							{formatMessage({ id: translationKey })}
						</p>
						<div className='mb-auto pt-[0.3rem]'>
							<InformationIconButton width={19} height={19} color='#808191' />
						</div>
					</CommonTooltip>
				</div>
			</div>
		</>
	);
};

export default OrganizeStatisticBox;
